import { api } from "./api";

export const uploadCsvFileApi = (params) => {
    return api.post(`/hub/resource/upload-csv`, params, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

export const createGlossaryApi = (params) => {
    return api.post(`/hub/resource/create-glossary`, JSON.stringify(params));
};


export const glossaryListApi = (params) => {
    return api.get(`/hub/resource/glossary-list`, { params: params });
};

export const deleteGlossaryApi = (params) => {
    return api.post(`/hub/resource/delete-glossary`, JSON.stringify(params));
};

export const assignPortalGlossaryApi = (params) => {
    return api.post(`/hub/resource/assign-portal-glossary`, JSON.stringify(params));
};

export const portalsDropDownApi = (params) => {
    return api.get(`/hub/resource/portals-list`, { params: params });
};